import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cart: [],
    openCart: false,
    tendered: 0,
    payment_method: "Cash",
    purchaser: "",
  },
  reducers: {
    addToCart: (state, action) => {
      state.cart = [...state.cart, action.payload];
    },
    removeItemFromCart: (state, action) => {
      state.cart = action.payload;
    },
    toggleCart: (state) => {
      state.openCart = !state.openCart;
    },
    tenderedAmount: (state, action) => {
      state.tendered = action.payload;
    },
    purchaserName: (state, action) => {
      state.purchaser = action.payload;
    },
    setPaymentMethod: (state, action) => {
      state.payment_method = action.payload;
    },
    resetCart: (state) => {
      state.cart = [];
      state.tendered = 0;
      state.payment_method = "Cash";
      state.purchaser = "";
      state.openCart = false;
    },
    increaseCartItemQuantity: (state, action) => {
      state.cart = action.payload;
    },
    decreaseCartItemQuantity: (state, action) => {
      state.cart = action.payload;
    },
  },
});

export const {
  addToCart,
  resetCart,
  toggleCart,
  removeItemFromCart,
  increaseCartItemQuantity,
  decreaseCartItemQuantity,
  tenderedAmount,
  setPaymentMethod,
  purchaserName,
} = cartSlice.actions;
export default cartSlice.reducer;
